import {Component, Input, OnInit} from '@angular/core';
import {DeckType, LinkageDirection, LinkageType} from '../../shared/card-deck';
import {MatSidenav} from '@angular/material/sidenav';
import {Observable} from 'rxjs';
import {CardPattern} from '../../shared/card-pattern';
import {CardStoreService} from '../../shared/card-store.service';
import {EditorService} from '../shared/editor.service';
import {CardWebService} from '../../shared/card-web.service';
import {CardWebElement} from '../../shared/card-web-element';
import {LayoutService} from '../shared/layout.service';
import {ElementLock} from "../shared/ElementLock";

@Component({
  selector: 'em-linkage-card',
  templateUrl: './linkage-card.component.html',
  styleUrl: './linkage-card.component.css'
})
export class LinkageCardComponent implements OnInit {
    constructor(
        private ls: LayoutService,
        private cs: CardStoreService,
        private es: EditorService,
        private cw: CardWebService
    ) {
    }
    @Input() linkageCardWebElement: CardWebElement;
    @Input() rightSidenav: MatSidenav;
    @Input() elementLock: ElementLock;

    cardPattern$: Observable<CardPattern>;
    buttoncolor;

    protected readonly DeckType = DeckType;
    protected readonly LinkageDirection = LinkageDirection;

    ngOnInit(): void {
        if (this.linkageCardWebElement.linkageType === LinkageType.oneToOne ||
            this.linkageCardWebElement.linkageType === LinkageType.oneToMany)
        {
            const referencedCardWebElement = this.cw.getCardWebElement(this.linkageCardWebElement.linkageSourceIds[0]);
            this.cardPattern$ = this.cs.getPatternCardWithCell(
                referencedCardWebElement.cardDeckId, referencedCardWebElement.id,
                referencedCardWebElement.cardDeckType);
        }
        this.buttoncolor = '';
    }

    canHaveBorder(partOfCard: ('up'|'down'), linkageDirection: LinkageDirection) {
        let result = false;
        if (partOfCard === 'up') {
            if (this.linkageCardWebElement.linkageType === LinkageType.oneToOne ||
                this.linkageCardWebElement.linkageType === LinkageType.manyToOne) {
                result = true;
            }else{
                switch (linkageDirection) {
                    case LinkageDirection.left: {
                        result = this.linkageCardWebElement.linkageUpLeftDirection;
                        break;
                    }
                    case LinkageDirection.middle: {
                        result = this.linkageCardWebElement.linkageUpMiddleDirection;
                        break;
                    }
                    case LinkageDirection.right: {
                        result = this.linkageCardWebElement.linkageUpRightDirection;
                        break;
                    }
                    default: {}
                }
            }
        }else if (partOfCard === 'down') {
            if (this.linkageCardWebElement.linkageType === LinkageType.oneToOne ||
                this.linkageCardWebElement.linkageType === LinkageType.oneToMany) {
                result = true;
            }else {
                switch (linkageDirection) {
                    case LinkageDirection.left: {
                        result = this.linkageCardWebElement.linkageDownLeftDirection;
                        break;
                    }
                    case LinkageDirection.middle: {
                        result = this.linkageCardWebElement.linkageDownMiddleDirection;
                        break;
                    }
                    case LinkageDirection.right: {
                        result = this.linkageCardWebElement.linkageDownRightDirection;
                        break;
                    }
                    default: {
                    }
                }
            }
        }
        return result;
    }

    public openSideMenu(preference: ('left'|'right'|'bottom')) {
        this.cardPattern$.subscribe(pattern => {
            this.es.setConnectionParams({cardPattern: pattern, cardId: this.linkageCardWebElement.id});
        });
        this.rightSidenav.toggle();
        this.cw.setConnectionPreference(preference, this.linkageCardWebElement.posX, this.linkageCardWebElement.posY);
    }
}
